// Ejemplo de un componente de búsqueda simple
import React, { useState, useEffect, useRef } from 'react';
import { Box, Button, TextField, InputAdornment, useMediaQuery, useTheme } from '@mui/material';
import { Search, QrCodeScanner } from '@mui/icons-material';
import DateTimePickerCustom from './calendar/DateTimePicker';

const SearchComponent = ({ onSearch, searchByDate = false, searchWhenType = false, barcodeIcon = false, width = '40%', focusTrigger = 0, onTabPress }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [searchQuery, setSearchQuery] = useState('');
  const [date, setDate] = useState('');
  const [openModalBarcode, setOpenModalBarcode] = useState(false);

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleChangeDate = (value) => {
    setDate(value);
  };

  const handleSearch = () => {
    if (onSearch) onSearch(searchByDate ? { date, searchQuery } : { searchQuery });
  };

  const handleBarcode = () => {
    setOpenModalBarcode(!openModalBarcode)
  }

  const barcode = () => <></>

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch(searchQuery);
      setSearchQuery('');
    }
    if (e.key === 'Tab' && onTabPress) {
      e.preventDefault();
      onTabPress();
    }
  };

  const inputRef = useRef();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select?.();
    }
  }, [focusTrigger]);

  return (
    <Box display='flex' flexDirection='row' sx={{ width: isMobile ? '100%' : width }}>
      {searchByDate && <DateTimePickerCustom label='Fecha' onChange={handleChangeDate} value={date} />}
      <TextField
        inputRef={inputRef}
        sx={{ width: '100%', alignSelf: 'center' }}
        size='small'
        type="text"
        value={searchQuery}
        variant='standard'
        color='primary'
        onKeyUp={(event) => {
          if (searchWhenType) {
            handleInputChange(event);
            handleSearch();
          }
        }}
        onChange={handleInputChange} InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: barcodeIcon && <Button endIcon={<QrCodeScanner />} onClick={handleBarcode} />
        }}
        onKeyDown={handleKeyDown}
        autoFocus
      />
      {!searchWhenType && !openModalBarcode && <Button size='small' sx={{ marginLeft: '10px' }} onClick={handleSearch}>Buscar</Button>}
      {/* {openModalBarcode && barcode()} */}
    </Box>
  );
};

export default SearchComponent;
